import styled from 'styled-components';

const CONTROLS_GUTTER = 48;
const DROPDOWNS_GUTTER = 30;

export const StyledControls = styled.div`
  background: #eee;
  > div {
    ${({ theme }) => theme.custom.helpers.LayoutContainer``};

    padding-bottom: 20px;
    padding-top: 20px;

    /* Dropdown Bar */
    display: flex;
    display: flex;
    flex-wrap: wrap;
    position: relative;
    @media ${({ theme }) => theme.custom.layouts.above_large} {
      flex-wrap: nowrap;
      align-items: center;
      justify-content: space-between;
    }
  }
`;
export const StyledControlsTitle = styled.div`
  flex: 0 0 100%;
  /* @include title--s; */
  text-align: center;
  padding-bottom: 20px;
  @media ${({ theme }) => theme.custom.layouts.above_large} {
    padding: 0;
    flex: 0 0 auto;
    padding-right: ${CONTROLS_GUTTER}px;
  }
`;

export const StyledControlsDropdowns = styled.div`
  display: flex;
  flex-wrap: wrap;
  flex: 1 1 100%;
  @media ${({ theme }) => theme.custom.layouts.above_large} {
    flex-wrap: nowrap;
    width: calc(100% + ${DROPDOWNS_GUTTER}px);
    margin-left: ${DROPDOWNS_GUTTER * -0.5}px;
    margin-right: ${DROPDOWNS_GUTTER * -0.5}px;
  }
`;
export const StyledControlDropdown = styled.div`
  flex: 0 0 auto;
  width: 100%;
  padding-bottom: 20px;
  @media ${({ theme }) => theme.custom.layouts.above_large} {
    width: calc(100% / 2);
    padding: 0 ${DROPDOWNS_GUTTER * 0.5}px;
  }
`;

export const StyledControlsResetButton = styled.div`
  flex: 0 0 auto;
  width: 100%;
  @media ${({ theme }) => theme.custom.layouts.above_large} {
    width: auto;
    padding-left: ${CONTROLS_GUTTER}px;
  }
`;
